import type { IconData } from '@stacksjs/iconify-core'

export const tabletCapsuleRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16.516 16.516c-3.64 3.64-6.48 6.613-8.682 9.007c-2.185 2.376-3.277 5.045-3.332 7.583c-.054 2.515.903 5.065 3.116 7.277s4.761 3.17 7.277 3.115c2.538-.055 5.206-1.146 7.582-3.331c2.394-2.202 5.367-5.042 9.008-8.682zM43.212 4.789C40.274 1.852 36.69.424 33.019.503c-3.648.08-7.22 1.642-10.203 4.387c-2.44 2.244-5.454 5.123-9.128 8.798s-6.554 6.687-8.798 9.128C2.145 25.8.582 29.37.503 33.019c-.08 3.67 1.349 7.255 4.286 10.193s6.522 4.365 10.193 4.285c3.648-.079 7.219-1.641 10.203-4.386c2.44-2.245 5.453-5.123 9.128-8.798s6.553-6.687 8.798-9.128c2.745-2.984 4.307-6.555 4.387-10.203c.079-3.671-1.35-7.256-4.286-10.193\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default tabletCapsuleRemix
